import React, { useState } from 'react';

// Soft blue ambient glow adapted from the pilot dashboard — the card surface
// stays white; a diffuse Jobasti-blue wash + border ring appears on hover.
const BLUE_GLOW =
  'linear-gradient(135deg, #bfdbfe 0%, #93c5fd 22%, #60a5fa 46%, #3b82f6 70%, #2563eb 100%)';

export const GlowCard = ({
  children,
  className = '',
  defaultGlow = false,
  glowOnHover = true,
  onClick,
  testId,
}) => {
  const [hovered, setHovered] = useState(false);
  const active = defaultGlow || (glowOnHover && hovered);

  return (
    <div
      onClick={onClick}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      data-testid={testId}
      className={`relative group h-full rounded-2xl transition-all duration-300 ${onClick ? 'cursor-pointer' : ''}`}
    >
      {/* Ambient diffuse blue glow */}
      <div
        aria-hidden="true"
        className={`absolute -inset-[3px] rounded-[22px] transition-all duration-500 pointer-events-none -z-10 ${
          active ? 'opacity-60 blur-xl scale-[1.01]' : 'opacity-0 blur-md scale-95'
        }`}
        style={{ background: BLUE_GLOW }}
      />
      {/* Crisp blue border ring on hover */}
      <div
        aria-hidden="true"
        className={`absolute -inset-[1.5px] rounded-[19px] transition-opacity duration-300 pointer-events-none ${
          active ? 'opacity-100' : 'opacity-0'
        }`}
        style={{ background: BLUE_GLOW }}
      />
      {/* Plain subtle border when idle */}
      <div
        aria-hidden="true"
        className={`absolute inset-0 rounded-2xl border border-slate-200 transition-opacity duration-300 pointer-events-none ${
          active ? 'opacity-0' : 'opacity-100'
        }`}
      />
      {/* Inner surface */}
      <div
        className={`relative w-full h-full bg-white rounded-2xl shadow-[0_1px_3px_rgba(16,24,40,0.06),0_1px_2px_rgba(16,24,40,0.04)] transition-shadow duration-300 ${
          active ? 'shadow-[0_10px_34px_rgba(37,99,235,0.14)]' : ''
        } ${className}`}
      >
        {children}
      </div>
    </div>
  );
};

export default GlowCard;
